<mat-dialog-content style="display: flex;justify-content: center;text-decoration: none;">
  <div class="row">
    <!-- <div class="col-4">
      <a class="btn btn-primary link" (click)="goToBailleur()">Bailleur</a>
    </div>
    <div class="col-4"></div> -->
    <div class="col-12">
      <a class="btn btn-primary" (click)="goToLogin()">Locataire</a>
    </div>
  </div>
</mat-dialog-content>